import Avatar from "../UI/Avatar/Avatar";
import Card from "../UI/Card/Card";
import { useHistory } from "react-router-dom";

const CardPerson = (props) => {
  const state = props.state ? props.state : "default";
  const person = props.person ? props.person : false;
  const score = person.score ? person.score : 0;
  const history = useHistory();

  const personClickHandler = (e) => {
    e.preventDefault();
    history.push(person.link);
  };

  if (person && "name" in person)
    return (
      <a
        href="javascript:void(0)"
        onClick={personClickHandler}
        className="Cards-list__item"
        style={{ textDecoration: "none" }}
      >
        <Card
          size="small"
          className={props.className}
          state={state}
          key={person.id}
        >
          <div className="Flex-container">
            <div className="Flex-col">
              <Avatar
                image={person.image}
                size="small"
                className="Card__image"
                isOnline=""
              />
            </div>

            <div className="Flex-col" style={{ flexGrow: 1 }}>
              <div className="Card__title">{person.name}</div>
              {score ? (
                <div className="Card__body">Заработано очков: {score}</div>
              ) : "На пути к успеху"}
            </div>
          </div>
        </Card>
      </a>
    );
};

export default CardPerson;
